module.exports = __webpack_public_path__ + "static/assets/ce20ae188e41ea941588ffb256067a3c.png";